import { defineComponent as _defineComponent } from 'vue';
import { faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BButton } from "bootstrap-vue";
import { computed, ref, watch } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ClickToEdit',
    props: {
        value: null,
        title: null
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        const editable = ref(false);
        const localValue = ref(props.value);
        const computedValue = computed(() => props.value);
        watch(() => editable.value, (value) => {
            if (!value) {
                emit("input", localValue.value);
            }
        });
        return { __sfc: true, props, emit, editable, localValue, computedValue, faSave, FontAwesomeIcon, BButton };
    }
});
